export const contentApapter = (values) => {
  return {
    ...values,
    content_type: values.file_type,
    content: values.resource_url,
    resource_url_slides: values.resource_url_slides,
    categories_id: values.categories?.map(({ id }) => id),
    focus_areas_ids: values.focus_areas?.map(({ id }) => id),
    tags_ids: values.tags?.map(({ id }) => id),
    contributing_factors_id: values.contributing_factors?.map(({ id }) => id),
    moods_id: values.moods?.map(({ id }) => id),
    author_name: values.author?.author,
    content_partner: values.author?.content_partner,
    name: values.title,
    description: values.author?.description,
    description_content: values.description,
    is_pro_athlete: values.is_pro_athlete,
  };
};
